document.addEventListener('DOMContentLoaded',()=>{
  const main=document.getElementById('avProductImage');
  const thumbButtons=[...document.querySelectorAll('[data-product-thumb]')];
  let galleryIndex=0;
  function showImage(index){
    if(!main||!thumbButtons.length)return;
    galleryIndex=(index+thumbButtons.length)%thumbButtons.length;
    const btn=thumbButtons[galleryIndex], img=btn&&btn.querySelector('img');
    if(img){main.src=img.src.replace(/width=180/,'width=1400');thumbButtons.forEach(b=>b.classList.remove('is-active'));btn.classList.add('is-active')}
  }
  thumbButtons.forEach((btn,i)=>btn.addEventListener('click',()=>showImage(i)));
  const prev=document.querySelector('.av-gallery-prev'),next=document.querySelector('.av-gallery-next');
  if(prev)prev.addEventListener('click',()=>showImage(galleryIndex-1));
  if(next)next.addEventListener('click',()=>showImage(galleryIndex+1));
  showImage(0);

  const variantsEl=document.getElementById('avProductVariants');
  const variantId=document.getElementById('avVariantId');
  const price=document.getElementById('avCurrentPrice'),compare=document.getElementById('avComparePrice'),badge=document.getElementById('avSaveBadge');
  const radios=[...document.querySelectorAll('.av-option-values input[type="radio"]')];
  let variants=[];
  try{variants=JSON.parse(variantsEl?.textContent||'[]')}catch(e){}
  const money=(cents)=>{
    const n=(Number(cents)/100).toFixed(2);
    return 'Rs. '+n;
  };
  function selectedVariant(){
    const selected={};
    radios.forEach(r=>{if(r.checked)selected[r.dataset.optionPosition]=r.value});
    return variants.find(v=>Object.keys(selected).every(k=>v['option'+k]===selected[k]))||null;
  }
  function updateVariant(){
    const v=selectedVariant(); if(!v)return;
    if(variantId)variantId.value=v.id;
    if(price)price.textContent=money(v.price);
    if(v.compare_at_price&&Number(v.compare_at_price)>Number(v.price)){
      if(compare){compare.textContent=money(v.compare_at_price);compare.style.display='inline'}
      if(badge){badge.textContent='Save '+Math.round((1-(Number(v.price)/Number(v.compare_at_price)))*100)+'%';badge.style.display='inline-flex'}
    }else{
      if(compare)compare.style.display='none'; if(badge)badge.style.display='none';
    }
    const colorRadio=radios.find(r=>r.checked&&Number(r.dataset.optionPosition)===1);
    if(colorRadio){
      const colorVariant=variants.find(x=>x.option1===colorRadio.value&&x.featured_image);
      if(colorVariant?.featured_image?.src){main.src=colorVariant.featured_image.src+'&width=1400'}
    } else if(v.featured_image?.src){main.src=v.featured_image.src+'&width=1400'}
    const add=document.querySelector('.av-add');
    if(add){add.disabled=!v.available;add.textContent=v.available?'ADD TO CART':'SOLD OUT'}
  }
  radios.forEach(r=>r.addEventListener('change',updateVariant));
  updateVariant();

  const toggle=document.querySelector('[data-filter-toggle]'),filter=document.querySelector('.av-filter');
  if(toggle&&filter)toggle.addEventListener('click',()=>filter.style.display=filter.style.display==='block'?'none':'block');
});

/* =========================================================
   AVENTRA CINEMATIC SLIDING HOMEPAGE
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const isHome = document.body.classList.contains('template-index');
  if (!isHome) return;

  const slides = [
    ...document.querySelectorAll('#MainContent .av-hero-v2'),
    ...document.querySelectorAll('#MainContent > .av-section'),
    ...document.querySelectorAll('#MainContent .av-story')
  ];

  if (slides.length > 1) {
    const nav = document.createElement('div');
    nav.className = 'av-slide-nav';
    nav.setAttribute('aria-label', 'Homepage sections');

    slides.forEach((slide, index) => {
      slide.classList.add('av-slide-section');
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'av-slide-dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to section ' + (index + 1));
      dot.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      nav.appendChild(dot);
    });

    document.body.appendChild(nav);

    const dots = [...nav.querySelectorAll('.av-slide-dot')];
    const updateDots = () => {
      let current = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const distance = Math.abs(slide.getBoundingClientRect().top);
        if (distance < best) {
          best = distance;
          current = i;
        }
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    };

    window.addEventListener('scroll', updateDots, { passive: true });
    updateDots();

    const controls = document.createElement('div');
    controls.className = 'av-slide-arrows';
    controls.innerHTML = '<button type="button" class="av-slide-arrow av-slide-up" aria-label="Previous section">↑</button>' +
                         '<button type="button" class="av-slide-arrow av-slide-down" aria-label="Next section">↓</button>';
    document.body.appendChild(controls);

    const goRelative = (direction) => {
      let current = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const distance = Math.abs(slide.getBoundingClientRect().top);
        if (distance < best) {
          best = distance;
          current = i;
        }
      });
      const target = Math.max(0, Math.min(slides.length - 1, current + direction));
      slides[target].scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    controls.querySelector('.av-slide-up').addEventListener('click', () => goRelative(-1));
    controls.querySelector('.av-slide-down').addEventListener('click', () => goRelative(1));
  }
});

/* Aventra dual-handle price range */
(function(){
  const ranges=document.querySelectorAll('[data-price-range]');
  ranges.forEach((wrap)=>{
    const min=wrap.querySelector('.av-range-min'), max=wrap.querySelector('.av-range-max');
    const minOut=wrap.querySelector('[data-price-min]'), maxOut=wrap.querySelector('[data-price-max]');
    const hiddenMin=wrap.querySelector('[data-price-hidden-min]'), hiddenMax=wrap.querySelector('[data-price-hidden-max]');
    const fill=wrap.querySelector('[data-range-fill]');
    if(!min||!max) return;
    const currency=(document.documentElement.getAttribute('data-currency-symbol')||'₹');
    const money=(value)=>currency+Number(value).toLocaleString('en-IN',{maximumFractionDigits:0});
    const update=()=>{
      let a=Number(min.value), b=Number(max.value);
      if(a>b) [a,b]=[b,a];
      min.value=a; max.value=b;
      minOut.textContent=Number(a).toLocaleString('en-IN',{maximumFractionDigits:0});
      maxOut.textContent=Number(b).toLocaleString('en-IN',{maximumFractionDigits:0});
      hiddenMin.value=a; hiddenMax.value=b;
      const total=Number(min.max)||1;
      const left=(a/total)*100, right=100-(b/total)*100;
      fill.style.left=left+'%'; fill.style.right=right+'%';
      min.style.zIndex=(a>b-1)?4:3;
      max.style.zIndex=4;
    };
    min.addEventListener('input',()=>{ if(Number(min.value)>Number(max.value)) min.value=max.value; update(); });
    max.addEventListener('input',()=>{ if(Number(max.value)<Number(min.value)) max.value=min.value; update(); });
    update();
  });
})();


/* Aventra checkout terms gate */
document.addEventListener('DOMContentLoaded',()=>{
  const terms=document.getElementById('AventraTerms');
  const checkout=document.getElementById('AventraCheckout');
  const note=document.getElementById('AventraTermsNote');
  if(!terms||!checkout)return;
  const sync=()=>{
    checkout.disabled=!terms.checked;
    if(note)note.classList.toggle('is-hidden',terms.checked);
  };
  terms.addEventListener('change',sync);
  sync();
});
